import { Controller } from "@hotwired/stimulus"

// Frame de la página de sección: la sección nueva entra con sus primeras fotos ya descargadas, con un tope de
// espera, en vez de entrar con las fotos en blanco. Doc: storefront_catalog.md → "Página de sección"
export default class extends Controller {
  static values = { photos: { type: Number, default: 6 }, wait: { type: Number, default: 500 } }

  // turbo:before-frame-render del propio frame (no del load-more anidado): detiene el render hasta decodificar las
  // primeras fotos (las que caben en la pantalla) o hasta que venza el tope; una sección sin fotos entra de inmediato
  beforeRender(event) {
    if (event.target !== this.element) return
    const sources = [...event.detail.newFrame.querySelectorAll("img.product-card__img")]
      .slice(0, this.photosValue).map(img => img.src)
    if (!sources.length) return
    event.preventDefault()
    const decoded = Promise.allSettled(sources.map(src => Object.assign(new Image(), { src }).decode()))
    const cap = new Promise(resolve => setTimeout(resolve, this.waitValue))
    Promise.race([decoded, cap]).then(event.detail.resume)
  }
}
